import i18n from "../../../../constants/i18n";
import { USER_CONVERSATIONS_HEADERS } from "../../../../constants/table-custom-headers/User";
import getUserMessageIdStore from "../../../../stores/user-store/message-id-store";
import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import React from "react";
import SocialMediaBadWordsCounter from "../../../../components/SocialMediaBadWordsCounter";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const UserMessageIdData = withLiteObserverAndTheme(() => {
  const searchedUser = getUserMessageIdStore().searchedUser.get();
  const userMessageIdDataOrdered =
    getUserMessageIdStore().userMessageIdDataOrdered.get();
  const messageIdData = getUserMessagesStore().getMessagesData(
    userMessageIdDataOrdered,
    searchedUser
  );
  const socialMediaBadWordsCount =
    getUserMessagesStore().getBadWordsAndSocialMediaCount(messageIdData);

  return (
    <React.Fragment>
      <SocialMediaBadWordsCounter
        socialMediaBadWordsCount={socialMediaBadWordsCount}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={USER_CONVERSATIONS_HEADERS}
        rows={messageIdData}
        title={i18n.get("USER_MESSAGES_ID_TABLE")}
        shouldBeFlagged={false}
        titleKey={"USER_MESSAGES_ID_TABLE"}
      />
    </React.Fragment>
  );
});
export default UserMessageIdData;
